import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'components/ui/Modal'
import { OdinButton } from '@/components/ui/odin/odin-button'
import { OdinToggle } from '@/components/ui/odin/form/odin-toggle'
import { useModal } from 'providers/ModalProvider'
import { consentActions, consentSelectors } from 'store/consent'

export const CookiePreferencesModal = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { closeModal } = useModal()
  const current = useSelector(consentSelectors.analytics)
  const [analytics, setAnalytics] = useState<boolean>(current === true)

  const save = () => {
    dispatch(consentActions.setAnalyticsConsent(analytics))
    closeModal()
  }

  return (
    <Modal onClose={closeModal}>
      <ModalHeader title={t('cookiePreferences.title')} icon="cookie-bite" />
      <ModalBody>
        <p className="mt-0 mb-4 text-sm text-muted-foreground">{t('cookiePreferences.intro')}</p>

        <div className="flex items-start justify-between gap-4 py-3">
          <div className="flex flex-col gap-1">
            <p className="m-0 text-sm font-medium">{t('cookiePreferences.necessaryTitle')}</p>
            <p className="m-0 text-sm text-muted-foreground">{t('cookiePreferences.necessaryDesc')}</p>
          </div>
          <span className="shrink-0 text-xs font-medium text-muted-foreground">{t('cookiePreferences.always')}</span>
        </div>

        <div className="h-px w-full bg-border" />

        <OdinToggle
          className="py-3"
          checked={analytics}
          onCheckedChange={setAnalytics}
          label={t('cookiePreferences.analyticsTitle')}
          description={t('cookiePreferences.analyticsDesc')}
        />
      </ModalBody>
      <ModalFooter>
        <OdinButton onClick={save} className="w-full">
          {t('cookiePreferences.save')}
        </OdinButton>
      </ModalFooter>
    </Modal>
  )
}
